import { Box, Button, Flex, styled } from "@chakra-ui/react"
import { useLayoutEffect, useRef, useState } from "react"
import { FaUser } from "react-icons/fa"
import { FaPersonWalkingArrowLoopLeft } from "react-icons/fa6"
import "@fontsource/jua/400.css"
import { useIsMobileDevice } from "src/util/browser"

const Span = styled("span")

type Props = {
  type: "2D" | "3D" | "text"
  onClick: () => unknown
  text?: JSX.Element
  iconSize?: string
  borderRadius: string
  height: string
  width: string
}

export function PerspectiveBtnAlt({
  height,
  width,
  type,
  text,
  onClick,
  iconSize = "55%",
  borderRadius,
  ...props
}: Props & React.CSSProperties) {
  const isMobile = useIsMobileDevice()

  return (
    <Flex
      alignItems={"center"}
      justifyContent="center"
      onClick={isMobile ? null : onClick}
      onTouchStart={isMobile ? onClick : null}
      height={height}
      width={width}
      style={{
        aspectRatio: "4/2"
      }}
      bg="#212121"
      border={props.border ?? "4px solid currentColor"}
      borderRadius={borderRadius}
      outline="none"
      transition="background .25s ease"
      _hover={
        !isMobile && {
          bg: "black"
        }
      }
      _active={{}}
      _focus={{}}
    >
      {type === "2D" ? (
        <FaUser width="100%" height="100%" size={iconSize} />
      ) : type === "3D" ? (
        <FaPersonWalkingArrowLoopLeft
          width="100%"
          height="100%"
          size={iconSize}
        />
      ) : type === "text" ? (
        <Span fontFamily="Jua">{text}</Span>
      ) : (
        <>
          {import.meta.env.MODE === "development" ? (
            <>{new Error("Unhandled button type")}</>
          ) : (
            <></>
          )}
        </>
      )}
    </Flex>
  )
}
